export default __webpack_public_path__ + "static/media/adobeps.1591741e.svg";